<template>
  <div>
    <div class='title-row'>
      <span class='title' @click='initList'>营收情况一览-{{ searchCondition.year || '' }}年</span>
      <el-date-picker
        style='width: 120px'
        clearable
        format='yyyy年'
        placeholder='选择年'
        type='year'
        v-model='searchCondition.year' value-format='yyyy' @change='handleQuery'>
      </el-date-picker>
      &nbsp;
      <el-select v-model='searchCondition.artist_id' placeholder='组内红人' style='width: 220px' @change='handleQuery'
                 clearable filterable>
        <el-option :label='`${kol.nickname}`' :value='`${kol.id}`' v-for='kol in kolOptions' :key='kol.id'>
          <span style='float: left'>{{ kol.nickname }}</span>
          <span style='float: right;font-weight: lighter'>『{{ kol.sign_status === 'Y' ? '在约' : '签约' }}』</span>
        </el-option>
      </el-select>
      <el-button @click='loadKolOptions' icon='el-icon-refresh' type='text' title='点击刷新红人选项'></el-button>
    </div>

    <br>
    <div class='default-table'>
      <ape-table show-summary	 :columns='columns' :data='dataList'  :loading='loading' max-height='500' border>
      </ape-table>
    </div>

    <div v-if='isHiddenbtn'>
      <LineChart ref='refRevenueMonthDataChart' :dataList='dataList' :title="'营销'"></LineChart>
      <el-divider />
      <ContrastChart :searchCondition='searchCondition' />
    </div>


  </div>
</template>

<script>
import ApeTable from '../components/ApeTable'
import LineChart from '../components/LineChart'
import GroupSelect from '../components/GroupSelect'
import ContrastChart from '../components/contrastChart'

export default {
  name: 'RevenueMonthlyData',
  components: { ApeTable, LineChart, GroupSelect, ContrastChart },
  props: {
    condition: {
      type: Object,
      default: () => ({ year: null, group_id: null, group_name: '', quarter: 0, release_status: 'Y' })
    },
    isHiddenbtn: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    condition: {
      immediate: true,
      deep: true,
      handler(val) {
        this.searchCondition.year = val.year
        this.searchCondition.group_id = val.group_id
        this.loadKolOptions()
        this.initList()
      }
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      columns: [],
      kolOptions: [],
      searchCondition: { year: null, group_id: null, artist_id: null },
    }
  },
  methods: {
    //该组当前的红人
    async loadKolOptions() {
      if (this.searchCondition.group_id) {
        const { list } = await this.$api.loadGroupArtists(this.searchCondition.group_id)
        this.kolOptions = list
      }
    },
    async initList() {
      this.loadingStatus = true
      this.dataList = []
      if (this.searchCondition && this.searchCondition.year && this.searchCondition.group_id) {
        const data = await this.$api.getRevenueList(this.searchCondition)
        //revenueDatumList
        this.$nextTick(() => {
          this.dataList = data
          this.loadingStatus = false
        })
      }
    },
    handleQuery() {
      this.initList()
    },
  },
  created() {
    this.columns = [{
      value: 'platform_name',
      title: '平台',
      width: 120,
      align: 'center'
    }]
    for (let i = 1; i <= 12; i++) {
      this.columns.push({
        value: `month_${i}`,
        title: `${i}月`,
        width: 120,
        header_align: 'center',
        align: 'right'

      })
    }
    this.columns.push({
      value: 'total',
      title: '汇总',
      width: 120,
      header_align: 'center',
      align: 'right'
    })
  }
}
</script>

<style scoped>
.title-row {
  padding-left: 10px;
  margin-bottom: 10px;
}

.title {
  font-size: 16px;
  font-weight: 800;
  float: left;
  line-height: 30px;
  padding-right: 20px;
}
</style>


